<template>
  <mNavHeader v-if="currentEquipment != equipmentType.PC"></mNavHeader>
  <pcNavHeader v-else></pcNavHeader>
</template>
<script>
import { mapState } from 'vuex';
import { EquipmentType } from '@/constants';
import pcNavHeader from './pcNavHeader.vue';
import mNavHeader from './mNavHeader.vue';

export default {
  name: "",
  components: {
    pcNavHeader,
    mNavHeader,
  },
  data() {
      return {
        equipmentType: EquipmentType,
      }
  },
  computed: {
    ...mapState(['currentEquipment'])
  },
  methods: {
  },
  mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
</style>